import React  from 'react'

import SvgHello from '../images/svg/SvgHello'

const mystyle = {
    height: '25vh'
}
export default function Hello() {

    return (
        <SvgHello style={mystyle}></SvgHello>
    );
}


// WEBPACK FOOTER //
// ./src/components/Hello.jsx